export const path = ['/back/system/user', '/back/system/role', '/back/system/tissue', '/back/system/menu', '/back/content/essay']